export default function ccWireGoogleCSE() {
    const siteSearch = document.getElementById("site-search");
    if(siteSearch){
        siteSearch.addEventListener("submit", (e) => {
            e.preventDefault();
            const text = encodeURIComponent(document.getElementById("global-search-input").value);
            let type = "website";
            let url = "https://search.champlain.edu/?/";
            const officeString = "/office/";
            // No filter by default
            e.currentTarget.dataset.searchFilter = "none"
    
            // Check to see if this is an office page, if it is, we should limit search to only the office page by default
            if(window.location.pathname.startsWith(officeString)) {
                // If we are inside an office, check to see if we should filter search
                const officeFilteredSearchEnabled = document.querySelector('nav li[data-enable-search-filter]')?.dataset?.enableSearchFilter;
                
                if(officeFilteredSearchEnabled === "1"){
                    const officeHomepagePattern = /\/office\/[^\/]+/;
                    const officeHompageUrl = window.location.pathname.match(officeHomepagePattern);
                    if(officeHompageUrl) {
                        // Add filter value to data-search-filter attribute
                        e.currentTarget.dataset.searchFilter = officeHompageUrl[0];
                    }
                }
            }
            
            if (text !== "") {
                if (typeof e.currentTarget.dataset.searchType !== "undefined" && e.currentTarget.dataset.searchType !== type) {
                    type = e.currentTarget.dataset.searchType;
                }
                
                url += type;
                
                console.cclog(e.currentTarget.dataset.searchFilter);
                
                if (typeof e.currentTarget.dataset.searchFilter !== "undefined" && e.currentTarget.dataset.searchFilter !== "none") {
                    url += `/${text}/${window.location.hostname}${e.currentTarget.dataset.searchFilter}`;
                    window.location.href = url;
                } else {
                    window.location.href = url + "/" + text;
                }
            }
        });
    }
}
